import React, { PropsWithChildren } from 'react';
import TopicsItemDropdownWrapper from './TopicsItemDropdownWrapper';
import useModal from '../../hooks/useModal';

export type Props = PropsWithChildren & {
  isMobileView: boolean;
  displayName: string;
};

/**
 * Wraps children in dropdown container depending on the breakpoint.
 */
const TopicsItemContainer = (props: Props) => {
  const { isMobileView, displayName, children } = props;

  const topicDropdown = useModal();

  return isMobileView ? (
    <TopicsItemDropdownWrapper modalProps={topicDropdown} name={displayName}>
      {children}
    </TopicsItemDropdownWrapper>
  ) : (
    <>{children}</>
  );
};

export default TopicsItemContainer;
